import React, { Dispatch, SetStateAction, useEffect, useState } from "react"
import { PROVIDER_TYPE } from "lib/types/common"
import { Provider } from "lib/types/generated/graphql-types"

import { Container, EmptyList, Wrapper } from "components/Ui/Table/Shared.styled"

import ErrorMessage from "components/Ui/Messages/ErrorMessage"
import TableBlurLoading from "components/Ui/Table/TableBlurLoading"
import { CustomGiftCardConfigTableRow, getLoadingRow } from "./CustomGiftCardConfigTableRow"
import TableHeader from "../../Ui/Table/TableHeader"

type Props = {
  providers: Provider[]
  error: object | undefined
  setEditId?: Dispatch<SetStateAction<string>>
  loading: boolean
}

export const CustomGiftCardConfigTable = ({ providers, setEditId, error, loading }: Props) => {
  const [customProviders, setCustomProviders] = useState<Provider[]>([])

  const tableHeader = (
    <TableHeader iconHeader={true}>
      <div>Id</div>
      <div className="hideOnSmallScreens">Base URL</div>
      <div className="hideOnSmallScreens">Token URL</div>
      <div className="hideOnSmallScreens hideOnMediumScreens">Created</div>
      <div className="hideOnSmallScreens hideOnMediumScreens">Updated</div>
    </TableHeader>
  )

  useEffect(() => {
    if (providers) {
      setCustomProviders(
        providers?.filter((provider) => provider.type === PROVIDER_TYPE.BSG_GIFT_CARD)
      )
    }
  }, [providers])

  if (loading)
    return <TableBlurLoading numberOfRows={1} tableHeader={tableHeader} rows={getLoadingRow()} />

  if (customProviders?.length < 1)
    return (
      <EmptyList>
        <p> No configurations added</p>
      </EmptyList>
    )

  return (
    <Wrapper>
      <Container>
        {error && (
          <ErrorMessage
            showRefreshButton
            message={
              <>
                Error loading Custom Gift Card settings. Try refreshing the page, or contact{" "}
                <a href="mailto:support@brinkcommerce.com">support</a>.
              </>
            }
          />
        )}
        {tableHeader}
        {[...customProviders].map((customProvider) => (
          <CustomGiftCardConfigTableRow
            key={customProvider.id}
            id={customProvider.id}
            setEditId={setEditId}
          />
        ))}
      </Container>
    </Wrapper>
  )
}
